<template>
    <div id="process"  :style="{width:clientW+'px',height:clientH+'px'}" style="margin:0 auto">
        <div class="processframe">
            <div class="processframe-title">
                <img :src="imgPath+'processtitle.png'" alt="">
            </div>
            <div class="processframe-content">
                <div class="processframe-fires">
                    <h2>（一）顺德国际营商环境推介会</h2>
                    <table>
                        <thead>
                            <th>议程安排</th>
                            
                        </thead>
                        <tbody>
                                <tr>
                                    <td>15:30-16:00</td>
                                    <td>签到</td>
                                </tr>
                                <tr>
                                    <td>16:00-16:10</td>
                                    <td>播放顺德宣传片</td>
                                </tr>
                                <tr>
                                    <td>16:10-16:25</td>
                                    <td>顺德营商环境推介（拟请区领导推介）</td>
                                </tr>
                                <tr>
                                    <td>16:25-16:35</td>
                                    <td>顺德龙头企业发布科创项目和需求</td>
                                </tr>
                                <tr>
                                    <td>16:35-16:45</td>
                                    <td>顺德日资企业分享发展经验</td>
                                </tr>
                                <tr>
                                    <td>16:45-18:20</td>
                                    <td>座谈交流</td>
                                </tr>
                            </tbody>
                    </table>
                </div>
                <div class="processframe-second">
                    <h2>（二）寻味顺德——世界美食之都顺德全国路演活动（上海站）</h2>
                    <table>
                        <thead>
                            <th>议程安排</th>
                            
                        </thead>
                        <tbody>
                                <tr>
                                    <td>18:30-18:40</td>
                                    <td>暖场活动：香云纱走秀</td>
                                </tr>
                                <tr>
                                    <td>18:40-18:45</td>
                                    <td>嘉宾介绍</td>
                                </tr>
                                <tr>
                                    <td>18:45-18:55</td>
                                    <td> PPT推介：顺德城市、美食旅游资源推介</td>
                                </tr>
                                <tr>
                                    <td>18:55-20:30</td>
                                    <td>顺德美食品鉴宴会</td>
                                </tr>
                                
                            </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="back" @click="black">
            <img :src="imgPath+'back.png'" alt="">
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            clientW:document.body.clientWidth,
            clientH:document.body.clientHeight,
            imgPath:imgPath
        }
    },
    created(){
        this.getViewScale();
    },
    methods: {
         getViewScale(){
            if(this.clientW >= 750){
                this.clientW = 414;
                this.clientH = 730;
            }
            if(this.clientH/this.clientW > 1.5 && this.clientH/this.clientW < 1.6){
                this.screenParm = "smallScreen";
            }else if(this.clientH/this.clientW <= 1.5){
                this.screenParm = "superSmallScreen";
            }else if(this.clientH/this.clientW >= 1.8){
                this.screenParm = "bigScreen";
            }else{
                this.screenParm = "middleScreen";
            }
        },
        black(){
            this.$router.back(-1);//放回上一页
        }
    },
}
</script>
<style lang="less" scoped>
@base:46.875rem;
#process{
    background-image: url(https://t.shundecity.com/shzstjh2021/Home/View/Index/images/otherbg.png);
    background-size: 100% 100%;
    position: relative;
    .processframe{
        width: 90%;
        height: 80%;
        padding: 70/@base 20/@base 20/@base;
        position: absolute;
        top:5%;
        left: 50%;
        transform: translateX(-50%);
        background-color: rgba(255, 255, 255, 0.8);
        border-radius: 10px;
        box-shadow:  0 0 20px 10px rgba(255, 255, 255, 0.3);
        .processframe-title{
            width:334/@base;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%,-30%);
        }
        .processframe-content{
            width: 100%;
            height: 100%;
            overflow-y: auto;
            .processframe-fires{
                margin-bottom: 30/@base;
                h2{
                    text-align: center;
                    margin-bottom: 20/@base;
                }
                tr td:nth-of-type(1){
                    width: 30%;
                }
            }
            .processframe-second{
                h2{
                    text-align: center;
                    margin-bottom: 20/@base;
                }
                tr td:nth-of-type(1){
                    width: 30%;
                }
            }
        }
    }
    .back{
        position: absolute;
        width: 113/@base;
        left: 50%;
        top: 88%;
        transform: translateX(-50%);
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/Process.vue